// extracted by mini-css-extract-plugin
export default {"tabs":"ReportsPage_tabs__Fn1EJ","dashboardTab":"ReportsPage_dashboardTab__FonU4"};